import React, { useState } from 'react';
import CompletedItemIcon from '../../../../assets/images/Completed Item Icon.svg';
import DownloadIcon from '../../../../assets/images/download.svg';
import PrintIcon from '../../../../assets/icons/raw/Print.svg';
import './CountertopUniversityCertificateViewer.scss';
import { CountertopUniversityCertificateViewerContentProps } from '../types/CountertopUniversityCertificateViewerContentProps';

const CountertopUniversityCertificateViewerContent: React.FC<CountertopUniversityCertificateViewerContentProps> = ({ email, date, certUrl }) => {
    const pdfUrlWithZoom = certUrl ? `${certUrl}#zoom=58` : '';
    const [hasError, setHasError] = useState(false);

    return (
        <div className="certification-content-container">
            <div className="certification-document-container" style={{ display: 'flex', flexDirection: 'column', height: '600px', flex: 1 }}>
                {certUrl && !hasError && (
                    <iframe
                        src={pdfUrlWithZoom}
                        title="Certificate PDF"
                        style={{ width: '110%', height: '750px', flex: 1, border: 'none' }}
                        onError={() => setHasError(true)}
                    ></iframe>
                )}
                {(!certUrl || hasError) && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '600px', color: '#d9534f', fontWeight: 'bold', textAlign: 'center', padding: '0 20px' }}>
                        Your certificate is not available to preview right now. Please try again later or contact support if the issue persists.
                    </div>
                )}
            </div>
            <div className="certification-info-container" style={{ marginLeft: '100px' }}>
                <div className='left-panel-header-text'>Certificate Completion</div>
                <div className="certification-info-header">
                    <img className="certification-completed-icon" src={CompletedItemIcon} alt="Completed Icon" />
                    <span className="certification-completed-text">Certificate Emailed</span>
                </div>
                <div className="certification-email">{email}</div>
                <div className="certification-date">{date}</div>

                <div className="certification-download-container" style={{ cursor: 'pointer' }}>
                    <div className="certification-download-icon">
                        <img className="certification-download-image" src={DownloadIcon} alt="Download Icon" />
                    </div>
                    <span className="certification-download-text">
                        <a href={certUrl} download="Certificate.pdf" target="_blank" rel="noopener noreferrer">
                            Download Certificate
                        </a>
                    </span>
                </div>

                <div className="certification-print-container">
                    <div className="certification-print-icon">
                        <img className="certification-print-image" src={PrintIcon} alt="Print Icon" />
                    </div>
                    <span className="certification-print-text">
                        <a href={certUrl} target="_blank" rel="noopener noreferrer">Print Certificate</a>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default CountertopUniversityCertificateViewerContent;